import React from 'react';
import HeroSection from './HeroSection';
// import Issues from '../reports/issues/Issues';
import Reviews from '../reviews/Reviews';
import ContactUsSection from '../contact/ContactUsSection';
import HowItWorks from './HowItWorks';
import ReviewSection from '../reviews/ReviewSection';
// import HomeStats from '../stats/HomeStats';

export default function Home() {
  return (
    <div className=''>
      <HeroSection />
      {/* <HomeStats /> */}
      <HowItWorks />
      {/* <AboutSection />
      <FeaturesSection /> */}
      {/* <HowItWorks /> */}
      {/* <Issues /> */}
      {/* <EventTimelineSection /> */}
      {/* <Reviews /> */}
      <ReviewSection/>
      <ContactUsSection/>
    </div>
  );
}
